import { render, staticRenderFns } from "./Viber.vue?vue&type=template&id=3ed16016"
import script from "./Viber.vue?vue&type=script&lang=js"
export * from "./Viber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed16016')) {
      api.createRecord('3ed16016', component.options)
    } else {
      api.reload('3ed16016', component.options)
    }
    module.hot.accept("./Viber.vue?vue&type=template&id=3ed16016", function () {
      api.rerender('3ed16016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/Viber.vue"
export default component.exports